module.exports = __webpack_public_path__ + "img/预付款保函.70e041c4.png";